import React, { PropTypes } from "react";
import classNames from "classnames";
import {
  FormattedDate,
  FormattedMessage,
  FormattedRelative,
  FormattedTime,
} from "react-intl";
import moment from "moment";

import FollowUpCommentsFields from "./FollowUpCommentsFields";
import { EditButton } from "../../../../../common";

const FollowUpComment = (props) => {
  const { comment, userId, followUpId, updateComment } = props;
  const { createdAt, createdByUserId } = comment;

  const commentClasses = classNames({
    "follow-up-comment": true,
    "system-comment": createdByUserId == null,
  });

  const authorName = createdByUserId ? (
    comment.createdByUser.firstName + " " + comment.createdByUser.lastName
  ) : (
    <FormattedMessage id="members.followUps.form.comments.systemComment" />
  );
  const canEdit = createdByUserId == props.userId;

  const difference = moment().diff(createdAt, "hours");
  const commentTime =
    difference > 23 ? (
      <span>
        <FormattedDate value={createdAt} /> <FormattedTime value={createdAt} />
      </span>
    ) : (
      <FormattedRelative value={createdAt} />
    );
  return (
    <div key={comment.followUpCommentId} className={commentClasses}>
      <div className="comment-meta">
        <span className="comment-author">{authorName}</span>
        {" - "}
        <span className="comment-date">{commentTime}</span>
        {canEdit && (
          <span className="comment-edit">
            <EditButton
              title={
                <FormattedMessage id="members.followUps.form.comments.edit" />
              }
              form={FollowUpCommentsFields}
              props={{ poppedUp: true, userId, followUpId }}
              data={comment}
              editFunction={updateComment}
              disableBackdrop={true}
              disabled={props.readOnly}
            />
          </span>
        )}
      </div>
      <div className="comment-body">{comment.value}</div>
    </div>
  );
};

FollowUpComment.propTypes = {
  comment: PropTypes.object,
  followUpId: PropTypes.number,
  updateComment: PropTypes.func,
  userId: PropTypes.number,
  readOnly: PropTypes.bool
};

export default FollowUpComment;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/comments/FollowUpComment.js